export function getFilestackImageFormat(mimetype: string) {
  switch (mimetype) {
    case 'image/tiff':
      return 'jpg';
    case 'image/svg+xml':
      return undefined;
    default:
      return 'webp';
  }
}
